<!--
 * @Autor: 毛萍萍
 * @Date: 2021-08-02 13:35:47
 * @LastEditTime: 2023-01-13 16:45:38
 * @LastEditors: pingping.mao
 * @Description: 封装select-tree组件
 * @FilePath: \common-web\src\components\private\tree-select\index.vue
-->
<template>
  <el-popover
    ref="popper"
    v-model="visible"
    :disabled="disabled"
    :visible-arrow="false"
    :trigger="trigger"
    placement="bottom-start"
    popper-class="select-tree-popover"
    style="min-width: 150px"
  >
    <div ref="moniInput" slot="reference" class="w100" style="display: block" @click="openTree">
      <div
        class="moni-input-section"
        :class="{ 'is-focus': visible, disabled: selectTreeDisabled }"
      >
        <div class="moni-input">
          <!-- placeholder -->
          <div v-if="selectedData.length === 0" class="moni-placeholder">
            <span>{{ placeholder }}</span>
          </div>
          <!-- 单选 -->
          <div v-if="!multiple && selectedData.length === 1" class="moni-single-item">
            <span>{{ singleValue }}</span>
          </div>
          <!-- 多选 -->
          <ul
            v-if="multiple && selectedData.length"
            class="moni-multiple-ul"
            :class="{ 'tags-ul': showCollapseTags, 'no-tags-ul': !showCollapseTags }"
          >
            <template v-if="!showCollapseTags">
              <li v-for="(io, index) in selectedData" :key="index" class="moni-multiple-item">
                <span>{{ io[defaultProps.label] || io }}</span>
                <span @click.stop="deleteCheckedNode(io, index)">
                  <i class="el-icon-error"></i>
                </span>
              </li>
            </template>
            <template v-else>
              <template v-for="i in showCollapseTags">
                <li v-if="selectedData[i - 1]" :key="i" class="moni-multiple-item">
                  <span>
                    {{
                      (selectedData[i - 1] && selectedData[i - 1][defaultProps.label]) ||
                        selectedData[i - 1]
                    }}
                  </span>
                  <span @click.stop="deleteCheckedNode(selectedData[i - 1], i - 1)">
                    <i class="el-icon-error"></i>
                  </span>
                </li>
              </template>
              <li v-if="selectedData.length > showCollapseTags" class="moni-multiple-item">
                <span class="tags">+ {{ selectedData.length - showCollapseTags }}</span>
              </li>
            </template>
          </ul>
        </div>
        <div
          v-if="clearable && !!selectedData.length"
          class="moni-input-delete"
          @click.stop="deleteNode"
        >
          <i class="el-icon-error"></i>
        </div>
        <div class="moni-input-arrow">
          <i :class="{ 'el-icon-arrow-down': true, 'is-reverse': visible }"></i>
        </div>
      </div>
    </div>
    <div
      class="select-tree-section"
      :style="{
        width: `${treeWidth}px`,
        'min-height': '200px',
        'max-height': `${height}px`,
        overflow: 'auto'
      }"
    >
      <div v-if="showSearch" class="select-tree-search">
        <el-input
          v-model="searchValue"
          :placeholder="$t('common.pleaseEnter')"
          @keyup.enter.native.stop="handleSearchTree"
        >
          <div slot="suffix" class="search-input__icon--search">
            <svg-icon
              style="margin-top: -20px"
              icon-class="search"
              class="search-icon cursor-p"
              @click="handleSearchTree"
            ></svg-icon>
          </div>
        </el-input>
      </div>
      <el-tree
        ref="tree"
        class="tree-select-tree"
        :highlight-current="!multiple"
        auto-expand-parent
        :show-checkbox="multiple"
        :data="data"
        :check-strictly="true"
        :node-key="nodeKey"
        :filter-node-method="filterNode"
        :default-expanded-keys="defaultExpandedKeys"
        :expand-on-click-node="false"
        :props="defaultProps"
        @current-change="handleChangeCurrent"
        @check-change="handleChangeChecked"
      ></el-tree>
    </div>
  </el-popover>
</template>

<script>
import { commonFilterNode } from "@/utils";
import { valueEquals } from "element-ui/src/utils/util";

export default {
  name: "TreeSelect",
  inject: {
    elForm: {
      default: ""
    }
  },
  props: {
    value: {
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ""
    },
    nodeKey: {
      type: String,
      default: "id"
    },
    treeData: {
      type: Array,
      default: () => []
    },
    multiple: {
      type: Boolean,
      default: false
    },
    height: {
      type: Number,
      default: 300
    },
    clearable: {
      type: Boolean,
      default: false
    },
    showSearch: {
      type: Boolean,
      default: true
    },
    defaultProps: {
      type: Object,
      default: () => ({
        children: "children",
        label: "label"
      })
    },
    collapseTags: {
      type: [Boolean, String, Number],
      default: false
    },
    showNode: {
      type: Boolean,
      default: false
    },
    defaultExpandedKeys: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      searchValue: "",
      visible: false,
      // trigger: "click",
      treeWidth: 200,
      selectedData: []
    };
  },
  computed: {
    singleValue() {
      if (!this.multiple && this.selectedData[0]) {
        return this.selectedData[0][this.defaultProps.label] || this.selectedData[0];
      } else {
        return "";
      }
    },
    data() {
      // 进行i数据回显
      this.updateDefaultSelected(true);
      return JSON.parse(JSON.stringify(this.treeData));
    },
    showCollapseTags() {
      if (typeof this.collapseTags === "boolean") {
        return this.collapseTags ? 1 : 0;
      } else if (typeof this.collapseTags === "string" || typeof this.collapseTags === "number") {
        return this.collapseTags >= 1 ? Math.round(Number(this.collapseTags)) : 1;
      } else {
        return 0;
      }
    },
    selectTreeDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    },
    trigger() {
      return this.selectTreeDisabled ? "manual" : "click";
    }
  },
  watch: {
    visible(newVal, oldVal) {
      if (newVal) {
        // this.$nextTick(() => {
        this.treeWidth = this.$refs.moniInput.clientWidth;
        // });
        // 进行数据回显
        // this.updateDefaultSelected();
        // 清空搜索
        this.searchValue = "";
        this.handleSearchTree();
      } else {
        // 删除选中
        // if (this.multiple){
        //   this.$refs.tree.setCheckedKeys([]);
        // } else {
        //   this.$refs.tree.setCurrentKey(null);
        // }
      }
    },
    value(newVal, oldVal) {
      this.$nextTick(() => {
        this.updatePopper();
      });
      // 进行数据回显
      this.updateDefaultSelected(true);
      if (!valueEquals(newVal, oldVal)) {
        this.dispatch("ElFormItem", "el.form.change", newVal);
      }
    }
  },
  created() {
    console.log(this.showNode);
  },
  methods: {
    openTree() {
      if (this.trigger === "click") {
        return;
      }
      if (!this.selectTreeDisabled) {
        this.visible = !this.visible;
      }
    },
    dispatch(componentName, eventName, params) {
      let parent = this.$parent || this.$root;
      let name = parent.$options.componentName;

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;

        if (parent) {
          name = parent.$options.componentName;
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params));
      }
    },
    updatePopper() {
      const { popper } = this.$refs;
      popper && popper.popperJS && popper.popperJS.update();
    },
    // 搜索
    handleSearchTree() {
      this.$refs.tree.filter(this.searchValue);
    },
    filterNode(value, data, node) {
      return commonFilterNode(value, data, node);
    },
    // 回显默认选中
    updateDefaultSelected(init = false) {
      this.$nextTick(() => {
        if (!this.value) {
          this.$refs.tree.setCheckedKeys([]);
          this.$refs.tree.setCurrentKey(null);
        } else if (Array.isArray(this.value)) {
          let values = [];
          if (this.showNode) {
            values = this.value.map(o => o[this.nodeKey]);
          } else {
            values = this.value;
          }
          this.$refs.tree.setCheckedKeys(values);
        } else {
          let val = null;
          if (this.value) {
            if (this.showNode) {
              val = this.value[this.nodeKey];
            } else {
              val = this.value;
            }
          }
          this.$refs.tree.setCurrentKey(val);
        }
        init && this.updateMoniInput();
      });
    },
    // 更新moni-input显示
    updateMoniInput() {
      if (!this.multiple) {
        const node = this.$refs.tree.getCurrentNode();
        if (node) {
          this.selectedData = [node];
        } else if (this.value) {
          this.selectedData = [
            this.showNode && this.value[this.nodeKey] ? this.value[this.nodeKey] : this.value
          ];
        } else {
          this.selectedData = [];
        }
      } else {
        const nodes = this.$refs.tree.getCheckedNodes();
        if (nodes.length) {
          this.selectedData = nodes;
        } else if (this.values && this.values.length) {
          this.selectedData = this.values;
        } else {
          this.selectedData = [];
        }
      }
    },
    // 单选改变
    handleChangeCurrent(data, node) {
      if (data.disabled) {
        let { value } = this;
        if (this.showNode) {
          value = this.value[this.nodeKey];
        }
        this.$refs.tree.setCurrentKey(value || null);
        return;
      }
      if (!this.multiple) {
        this.selectedData = [data];
        this.visible = false;
        if (this.showNode) {
          this.$emit("input", data);
        } else {
          this.$emit("input", data[this.nodeKey]);
        }
        this.$emit("change", this.selectedData);
      }
    },
    // 多选改变
    handleChangeChecked(data, val) {
      if (this.multiple) {
        const index = this.selectedData.findIndex(o => o[this.nodeKey] === data[this.nodeKey]);
        if (val) {
          // 进行去重过滤
          if (index === -1) {
            this.selectedData.push(data);
          }
        } else {
          // 查找相同id，进行删除
          if (index >= 0) {
            this.selectedData.splice(index, 1);
          }
        }
        if (this.showNode) {
          this.$emit("input", this.selectedData);
        } else {
          this.$emit(
            "input",
            this.selectedData.map(o => o[this.nodeKey])
          );
        }
        this.$emit("change", this.selectedData);
      }
    },
    // 删除多选
    deleteCheckedNode(data, index) {
      this.selectedData.splice(index, 1);
      this.$refs.tree.setChecked(data[this.nodeKey], false);
      this.$emit(
        "input",
        this.selectedData.map(o => o[this.nodeKey])
      );
      this.$emit("change", this.selectedData);
    },
    // 删除单选
    deleteSelectedNode() {
      this.selectedData = [];
      this.$refs.tree.setCurrentKey(null);
      this.$emit("input", "");
      this.$emit("change", this.selectedData);
    },
    deleteNode() {
      if (!this.multiple) {
        this.deleteSelectedNode();
      } else {
        this.selectedData = [];
        this.$refs.tree.setChecked([], false);
        this.$emit("input", []);
        this.$emit("change", this.selectedData);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.w100 {
  width: 100%;
}
.tree-select-tree {
  .el-icon-caret-right {
    margin-right: 5px;
    & + .el-checkbox {
      margin-right: 5px;
    }
  }
}

.select-tree-search {
  ::v-deep .el-input__inner {
    height: 32px;
    line-height: 32px;
  }
  .search-input__icon--search {
    line-height: 32px;
  }
}
 .moni-input-section {
    position: relative;
    // display: flex;
    width: 100%;
    min-width: 32px;
    min-height: 38px;
    cursor: pointer;
    border: 1px solid #d4d9e2;
    background-color: #fff;

    &.is-focus {
      &::before {
        content: "";
        position: absolute;
        top: -1px;
        right: -1px;
        bottom: -1px;
        left: -1px;
        border: 2px solid #00b259;
      }
    }

    &.disabled {
      cursor: not-allowed;
      background-color: #F9F9FB;
      border-color: #c6ccd7;

      &:hover {
        border-color: #c6ccd7;
      }

      .moni-input-arrow {
        color: #c6ccd7;
      }
    }

    &:hover {
      border-color: #00b259;
      .moni-input-delete {
        display: flex;
      }
      .moni-input-delete + .moni-input-arrow{
        display: none;
      }
    }

    .moni-placeholder {
      padding: 0px 0px 0px 15px;
      height: 38px;
      line-height: 38px;
      width: 100%;
      color: #c6ccd7;
      // white-space: nowrap;
      overflow: hidden;
    }

    .moni-input {
      // padding: 5px 0 5px 15px;
      // line-height: 24px;
      // flex: 1;
      // overflow: hidden;
      // position: absolute;
      // top: 0;
      position: relative;
      z-index: 2;
      width: calc(100% - 28px);

      // overflow: hidden;
      // display: flex;
      // transform: translateY(-50%);
    }

    .moni-el-input {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;

      .el-input__inner {
        height: 100% !important;
        padding-right: 32px;
        line-height: 30px;
        background-color: transparent;

        // border: none;
        &:focus {
          // background-color: rgba(255, 255, 255, 0.1);
        }
      }
    }

    .moni-input-arrow {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      // height: 100%;
      width: 28px;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .el-icon-arrow-down {
        color: #c6ccd7;
        font-size: 14px;
        transition: transform 0.3s;

        &.is-reverse {
          transform: rotate(-180deg);
        }
      }
    }

    .moni-input-delete {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      // height: 100%;
      width: 28px;
      display: none;
      // flex-direction: column;
      // justify-content: center;
      .el-icon-error {
        color: #c6ccd7;
        font-size: 14px;
        position: absolute;
        top: 50%;
        width: 100%;
        text-align: center;
        transform: translateY(-50%);
      }
    }

    .moni-single-item {
      height: 38px;
      padding: 0px 0px 0px 15px;
      display: flex;
      align-items: center;

      span:nth-child(1) {
        max-width: 100%;
        overflow: hidden;
        line-height: 28px;
        text-overflow: ellipsis;
        white-space: nowrap;
        flex: 1;
      }
    }

    .moni-multiple-ul{
      display: flex;
      flex-wrap: wrap;
      line-height: 0;
      align-items: center;
      // min-height: 38px;
      &.tags-ul{
        height: 38px;
      }
      &.no-tags-ul{
        min-height: 38px;
      }
    }

    .moni-multiple-item {
      display: inline-block;
      padding: 0 8px;
      // margin: 3px 4px 3px 0;
      margin: 0 0px 3px 6px;
      max-width: 100%;
      height: 20px;
      line-height: 20px;
      color: #505363;
      background: #eaedf3;
      border: 1px solid #d4d9e2;
      border-radius: 10px;

      span:nth-child(1):not(.tags) {
        display: inline-block;
        max-width: calc(100% - 18px);
        vertical-align: top;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      span:nth-child(1).tags {
        display: inline-block;
        max-width: 100%;
        vertical-align: top;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      span:nth-child(2) {
        vertical-align: top;
        margin-left: 4px;

        i {
          font-size: 14px;
          color: #C0C4CC;
        }

        &:hover {
          i {
            color: #00b259;
          }
        }
      }
    }
  }
.select-tree-section {
  &::-webkit-scrollbar {
    z-index: 11;
    width: 6px;
  }

  &::-webkit-scrollbar:horizontal {
    height: 6px;
  }

  &::-webkit-scrollbar-thumb {
    width: 6px;
    background: #ebecef;
    border-radius: 3px;
  }

  .el-tree-node {
    &[aria-disabled='true'] {
      &.is-current {
        // background-color: #edf2fc;
      }

      > .el-tree-node__content {
        cursor: not-allowed;
        background-color: #eaedf3;
      }
    }
  }

  .select-tree-search {
    padding: 10px;
  }

  .el-tree-node__content {
    height: 36px;
  }
}
.select-tree-popover {
  .el-popover__reference {
    display: block;
  }
}
</style>
